(function () {
  "use strict";
  var variant = 67906943254682, plan = 306091622554;
  window.__epPrepareMonthlyCheckout = function (lang) {
    var root = lang === "en" ? "/en/" : "/";
    async function request(path, body) {
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 12000);
      try {
        var response = await fetch(root + path, {
          method: body ? "POST" : "GET", credentials: "same-origin", cache: "no-store",
          signal: controller.signal, headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: body ? JSON.stringify(body) : undefined
        });
        if (!response.ok) throw new Error("checkout-unavailable");
        return await response.json();
      } finally { clearTimeout(timer); }
    }
    function monthlyLines(cart) { return (cart.items || []).filter(function (item) { return Number(item.variant_id) === variant; }); }
    function exactlyOne(lines) { return lines.length === 1 && lines[0].quantity === 1 && Number(lines[0].selling_plan_allocation && lines[0].selling_plan_allocation.selling_plan && lines[0].selling_plan_allocation.selling_plan.id) === plan; }
    async function prepare() {
      var cart = await request("cart.js"), lines = monthlyLines(cart);
      if (lines.length && !exactlyOne(lines)) return root + "cart";
      if (!lines.length) await request("cart/add.js", { items: [{ id: variant, quantity: 1, selling_plan: plan }] });
      cart = await request("cart/update.js", { attributes: { langue: lang === "en" ? "en" : "fr" } });
      if (!exactlyOne(monthlyLines(cart))) return root + "cart";
      return root + "checkout";
    }
    return navigator.locks && navigator.locks.request ? navigator.locks.request("ephore-ultimate-monthly-197", prepare) : prepare();
  };
})();
